import { createContext, use, useEffect, type ReactNode } from "react";

interface HeaderActionsValue {
  setActions: (node: ReactNode | null) => void;
  setNavigationActions: (node: ReactNode | null) => void;
}

export const HeaderActionsContext = createContext<HeaderActionsValue | null>(null);

/**
 * 헤더 오른쪽에 버튼을 얹는다.
 *
 * 관제의 알림 보내기·작업자 QR 처럼 **그 화면에만 있는 동작**이 갈 자리다. 헤더가
 * 셸로 올라가면서 페이지가 `right={...}` 로 직접 넘길 수 없게 됐다.
 *
 * 화면을 떠나면 스스로 걷힌다 — 남겨 두면 다음 화면에 남의 버튼이 뜬다.
 */
export function useHeaderActions(node: ReactNode | null, navigation: ReactNode = null): void {
  const ctx = use(HeaderActionsContext);
  const setActions = ctx?.setActions;
  const setNavigationActions = ctx?.setNavigationActions;

  useEffect(() => {
    if (!setActions) return;
    setActions(node);
    return () => setActions(null);
  }, [setActions, node]);

  useEffect(() => {
    if (!setNavigationActions) return;
    setNavigationActions(navigation);
    return () => setNavigationActions(null);
  }, [setNavigationActions, navigation]);
}
